// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__km71f","photo":"Sidebar_photo__EKnVE","mdColumn":"Sidebar_mdColumn__EbUA5","body":"Sidebar_body__nLH0T"};